export default "https://cdn-static.gokick.com/assets/f782299a76cdb7f85e2c64a970a00c34ce21ab93/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";